// extracted by mini-css-extract-plugin
export default {"card":"Card_card__48SLx","fadeIn":"Card_fadeIn__lPIy4","header":"Card_header__+W2T3"};